import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { OLAF, OZ, CANDY_APPLE_DARK, MARIGOLD } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
export default function CompatibilityIcon(_ref) {
  let {
    compatibilityType
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["compatibilityType"]);

  let backgroundColor;
  let iconName = 'success';

  switch (compatibilityType) {
    case 'COMPATIBLE_NONE':
      backgroundColor = CANDY_APPLE_DARK;
      iconName = 'remove';
      break;

    case 'COMPATIBLE_SOME':
      backgroundColor = MARIGOLD;
      break;

    case 'COMPATIBLE_MOST':
      backgroundColor = MARIGOLD;
      break;

    default:
      backgroundColor = OZ;
  }

  return /*#__PURE__*/_jsx(UIIconCircle, Object.assign({}, rest, {
    name: iconName,
    color: OLAF,
    backgroundColor: backgroundColor,
    borderWidth: 0,
    padding: 0.25,
    size: 8,
    style: {
      position: 'relative',
      top: -2
    }
  }));
}